import React from 'react';
import { Sparkles } from 'lucide-react';

export default function PageHero({ eyebrow, title, subtitle, kicker }) {
  return (
    <section className="relative pt-[130px] pb-16 lg:pt-[160px] lg:pb-24 overflow-hidden">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute -top-32 -left-24 w-[480px] h-[480px] rounded-full bg-[radial-gradient(closest-side,#FFD5B4,transparent_70%)] opacity-70" />
        <div className="absolute top-10 right-[-100px] w-[440px] h-[440px] rounded-full bg-[radial-gradient(closest-side,#FFE9D6,transparent_70%)] opacity-80" />
        <div
          className="absolute inset-0 opacity-[0.05]"
          style={{
            backgroundImage:
              'linear-gradient(#0F1B2D 1px, transparent 1px), linear-gradient(90deg, #0F1B2D 1px, transparent 1px)',
            backgroundSize: '48px 48px',
          }}
        />
      </div>
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="inline-flex items-center gap-2 rounded-full border border-orange-200 bg-white/80 backdrop-blur px-3.5 py-1.5 text-[12.5px] font-medium text-[#B54A15] shadow-sm">
          <Sparkles className="h-3.5 w-3.5" />
          {eyebrow}
        </div>
        <h1
          className="mt-6 text-[40px] sm:text-[52px] lg:text-[64px] leading-[1.05] tracking-[-0.025em] text-[#0F1B2D] font-semibold max-w-4xl"
          style={{ fontFamily: "'Space Grotesk', sans-serif" }}
        >
          {title}
        </h1>
        {subtitle && (
          <p className="mt-6 max-w-3xl text-[17px] leading-[1.7] text-slate-600">{subtitle}</p>
        )}
        {kicker && <div className="mt-6 text-[14px] text-[#E85A18] font-medium">{kicker}</div>}
      </div>
    </section>
  );
}
